<div class="page">
  <div class="page__container">
    <h1 class="page__title  h2">{{ 'mail_list_title' | translate }}</h1>
    <div class="my-5">
      <div ngbDropdown class="d-flex flex-column dropdown_small_device custom">
        <button class="btn btn-primary" id="dropdownAccountTab" #dropdown ngbDropdownToggle translate>common_list_tab_all</button>
        <div ngbDropdownMenu aria-labelledby="dropdownAccountTab">
          <button ngbDropdownItem translate (click)="nav.select(1); dropdown.innerText = $event.target.innerText">
            common_list_tab_all
          </button>
          <button ngbDropdownItem translate (click)="nav.select(2); dropdown.innerText = $event.target.innerText">
            mail_list_tab_sent
          </button>
          <button ngbDropdownItem translate (click)="nav.select(3); dropdown.innerText = $event.target.innerText">
            mail_list_tab_sending
          </button>
          <button ngbDropdownItem translate (click)="nav.select(4); dropdown.innerText = $event.target.innerText">
            mail_list_tab_scheduled
          </button>
          <button ngbDropdownItem translate (click)="nav.select(5); dropdown.innerText = $event.target.innerText">
            mail_list_tab_drafts
          </button>
        </div>
      </div>
      <ul ngbNav #nav="ngbNav" class="nav-tabs nav_tab_large_device custom" [(activeId)]="activeId">
        <li [ngbNavItem]="1">
          <a ngbNavLink translate>common_list_tab_all</a>
          <ng-template ngbNavContent>
            <wsb-email-history-all></wsb-email-history-all>
          </ng-template>
        </li>
        <li [ngbNavItem]="2">
          <a ngbNavLink translate>mail_list_tab_sent</a>
          <ng-template ngbNavContent>
            <wsb-email-history-sent></wsb-email-history-sent>
          </ng-template>
        </li>
        <li [ngbNavItem]="3">
          <a ngbNavLink translate>mail_list_tab_sending</a>
          <ng-template ngbNavContent>
            <wsb-email-history-running></wsb-email-history-running>
          </ng-template>
        </li>
        <li [ngbNavItem]="4">
          <a ngbNavLink translate>mail_list_tab_scheduled</a>
          <ng-template ngbNavContent>
            <wsb-email-history-scheduled></wsb-email-history-scheduled>
          </ng-template>
        </li>
        <li [ngbNavItem]="5">
          <a ngbNavLink translate>mail_list_tab_drafts</a>
          <ng-template ngbNavContent>
            <wsb-email-history-draft></wsb-email-history-draft>
          </ng-template>
        </li>
      </ul>
    </div>
    <div [ngbNavOutlet]="nav" class="mt-2"></div>
  </div>
</div>
